<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>

        <!-- Start row -->
        <div class="row">
            <!-- Main div -->
            <div class="col-xl-12 gutter-b">
                <div class="card card-custom">
                    <div class="card-header">
                        <div class="card-title">
                            <span class="card-icon">
                                <i class="fas fa-fire-alt text-danger"></i>
                            </span>
                            <h3 class="card-label">
                                Viral Search
                            </h3>
                        </div>
                    </div>
                    <div class="card-body">
                        <form method="POST" v-on:submit.prevent="doViralSearch">
                            <!-- Hashtag input -->
                            <b-form-group label-cols="4" label-cols-lg="2" label="Hashtag">
                                <b-form-input
                                    id="hashtags"
                                    name="hashtags"
                                    placeholder="Enter a single hashtag here"
                                    v-model="formhashtag"
                                ></b-form-input>
                            </b-form-group>

                            <!-- Hidden Submit -->
                            <b-button
                                variant="success"
                                type="Submit"
                                class="d-none"
                                :disabled="searchIsLoading"
                            >
                                Search
                            </b-button>
                        </form>
                    </div>
                    <div class="card-footer">
                        <b-button
                            variant="success"
                            class="offset-xl-2 col-xl-3"
                            @click="doViralSearch"
                            :disabled="searchIsLoading"
                        >
                            Search
                        </b-button>
                    </div>
                </div>
            </div>
            <!-- End col12 -->
        </div>
        <!-- End row -->

        <!-- Page display -->
        <div v-if="displayResults">
            <!-- Results row -->
            <transition-group name="list" tag="div" class="row">
                <div class="col-xl-3" v-for="(media, index) in viralmedia" :key="index">
                    <b-card
                        :title="media.nice_type + ' Post'"
                        :img-src="media.thumbnail"
                        img-alt="Image"
                        img-top
                        tag="article"
                        class="gutter-b"
                    >
                        <div class="separator separator-dashed separator-border-1"></div>

                        <b-card-text>
                            <div class="d-flex align-items-center mb-1 mt-1 rounded p-1">
                                <span class="svg-icon svg-icon-warning mr-5">
                                    <span class="svg-icon svg-icon-lg">
                                        <i class="fas fa-heart text-danger"></i>
                                    </span>
                                </span>
                                <div class="d-flex flex-column flex-grow-1 mr-2">
                                    <a
                                        class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                        >Likes</a
                                    >
                                </div>
                                <span class="font-weight-bolder py-1 font-size-lg text-danger">
                                    {{ addCommaToNumber(media.likes) }}
                                </span>
                            </div>
                            <div class="d-flex align-items-center mb-1 mt-1 rounded p-1">
                                <span class="svg-icon svg-icon-warning mr-5">
                                    <span class="svg-icon svg-icon-lg">
                                        <i class="fas fa-comments text-primary"></i>
                                    </span>
                                </span>
                                <div class="d-flex flex-column flex-grow-1 mr-2">
                                    <a
                                        class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                                        >Comments</a
                                    >
                                </div>
                                <span class="font-weight-bolder py-1 font-size-lg text-primary">
                                    {{ addCommaToNumber(media.comments) }}
                                </span>
                            </div>
                        </b-card-text>

                        <div class="separator separator-dashed separator-border-1"></div>

                        <!-- Caption -->
                        <b-button
                            v-b-toggle="media.shortcode + media.id"
                            variant="white"
                            class="col-12 text-success font-weight-bolder text-left"
                        >
                            <!-- <i class="fas fa-caret-right"></i> -->
                            <span class="when-opened">
                                <i class="fas fa-chevron-down mb-1"></i>
                            </span>
                            <span class="when-closed">
                                <i class="fas fa-chevron-right mb-1"></i>
                            </span>
                            View Caption
                        </b-button>
                        <b-collapse :id="media.shortcode + media.id">
                            <b-card-text class="pre-wrap gutter-b">
                                {{ media.caption }}
                                <span class="d-block pt-5">
                                    <a
                                        :href="'https://instagram.com/p/' + media.shortcode"
                                        target="_blank"
                                        class="font-weight-bolder"
                                        >View Original</a
                                    >
                                </span>
                            </b-card-text>
                        </b-collapse>

                        <div class="separator separator-dashed separator-border-1"></div>

                        <b-button
                            @click="getDownloadLink(media)"
                            variant="primary"
                            class="col-12 gutter-t text-left"
                            :class="(media.isLoading ? 'spinner spinner-white spinner-left' : '')"
                            :disabled="(media.isLoading)"
                            v-if="!media.downloadLink"
                        >
                            <i class="fas fa-download mr-2"></i>
                            Get Download Link
                        </b-button>
                        <b-button
                            v-if="media.downloadLink"
                            :href="media.downloadLink"
                            target="_blank"
                            variant="success"
                            class="col-12 gutter-t text-left"
                        >
                            <i class="fas fa-download mr-2"></i>
                            Download Now
                        </b-button>
                    </b-card>
                </div>
            </transition-group>
            <!-- End:: Results row -->

            <div v-if="isMore">
                <button
                    type="button"
                    class="btn btn-white btn-wide col-12 gutter-b"
                    @click="doMoreViralSearch()"
                >
                    <i class="fas fa-redo text-success"></i>
                    Load more results...
                </button>
            </div>
        </div>

        <!-- Preloader -->
        <PagePreloader v-if="searchIsLoading"></PagePreloader>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>
<style scoped>
.list-enter-active,
.list-leave-active,
.list-move {
    transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
    transition-property: opacity, transform;
}

.list-enter {
    opacity: 0;
    transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
    opacity: 1;
    transform: translateX(0) scaleY(1);
}

.list-leave-active {
    position: absolute;
}

.list-leave-to {
    opacity: 0;
    transform: scaleY(0);
    transform-origin: center top;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
    display: none;
}

.pre-wrap {
    white-space: pre-wrap;
}
</style>

<script>
// Defaults
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
// Mixins
import stringManagement from "@/mixins/stringManagement";
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "ViralSearchPage",
    mixins: [stringManagement, axiosErrorManagement],
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,
            searchIsLoading: false,

            // Displayers
            isSearchButtonDisabled: false,
            displayResults: false,

            // Error management
            errors: [],

            // Form management
            formhashtag: "",

            // Data management
            viralmedia: [],
            isMore: false,
            currentPage: 1,
            initialhashtag: "",
        };
    },

    methods: {
        // First method here
        doViralSearch() {
            // Reset errors
            this.errors = [];

            // Reset view
            this.displayResults = false;
            this.viralmedia = [];

            // Set loader
            this.searchIsLoading = true;

            // Reset status
            this.isMore = false;
            this.currentPage = 1;
            this.initialhashtag = "";

            // Perform query
            axios
                .post("viral/search", {
                    hashtags: this.formhashtag,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Set data
                        this.viralmedia = data.data;

                        // Enable display
                        this.displayResults = true;

                        // Check if there is more
                        this.isMore = data.more;

                        // Remember initial hashtag
                        this.initialhashtag = data.initialhashtag;
                    }

                    // Do error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((message) => {
                            this.errors.push({ type: message.type, message: message.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Stop preloader
                    this.searchIsLoading = false;
                });
        },

        doMoreViralSearch() {
            // Reset status
            this.errors = [];

            // Set preloader
            this.searchIsLoading = true;
            this.isMore = false;

            // Perform query
            axios
                .post("viral/search/more", {
                    hashtags: this.formhashtag,
                    pointer: this.currentPage,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Set data
                        this.viralmedia = this.viralmedia.concat(data.data);

                        // Check if there is more
                        this.isMore = data.more;

                        // Up the pointer count
                        this.currentPage++;
                    }

                    // Do error management
                    if (data.messages.length > 0) {
                        data.messages.forEach((message) => {
                            this.errors.push({ type: message.type, message: message.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Stop preloader
                    this.searchIsLoading = false;
                });
        },

        // Get download link for download
        getDownloadLink(media) {
            // Declare
            var downloadlink = false;

            // Switch status
            if (media.type == "GraphVideo") {
                // Set the preloader
                this.$set(this.viralmedia[this.viralmedia.indexOf(media, 0)], "isLoading", true);

                // Perform axios get
                axios
                    .get("viral/links/" + media.shortcode)
                    .then((response) => {
                        // Make pretty
                        var data = response.data;

                        // Check
                        if (data.status == "OK") {
                            downloadlink = data.data;
                        }

                        // Add the download link
                        this.$set(
                            this.viralmedia[this.viralmedia.indexOf(media, 0)],
                            "downloadLink",
                            downloadlink
                        );
                    })
                    .catch((error) => {
                        this.errors.push(this.handleAxiosErrors(error));
                    })
                    .finally(() => {
                        // Remove the preloader
                        this.$set(
                            this.viralmedia[this.viralmedia.indexOf(media, 0)],
                            "isLoading",
                            false
                        );
                    });
            } else {
                // Link is in the media
                var downloadlink = media.displayurl;

                // Add the download link
                this.$set(
                    this.viralmedia[this.viralmedia.indexOf(media, 0)],
                    "downloadLink",
                    downloadlink
                );
            }
        },
    },

    mounted() {
        // Set page preloader
        this.pageIsLoaded = true;
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Search", route: "search" },
            { title: "Viral Media", route: "viralsearch" },
            { title: "Viral Media Search Engine", route: "viralsearch" },
        ]);
    },
};
</script>
